import { render, staticRenderFns } from "./ProfileSubModuleChips.vue?vue&type=template&id=ee985424&scoped=true"
import script from "./ProfileSubModuleChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSubModuleChips.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileSubModuleChips.vue?vue&type=style&index=0&id=ee985424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee985424",
  null
  
)

export default component.exports